import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';

import Popup from '@/components/Popup/index.jsx';
import Detail from './detail';
import styles from './index.less';



const ShowWishDetail=(wish)=>{
  console.log(wish);
  sessionStorage.setItem('wish',JSON.stringify(wish))

  location.href=`/#/wishDetail/${wish.id}`;
  return;

  return new Promise(resolve=>{
    let popup = Popup(resolve);
    ReactDOM.render(
      <section className={styles.wrap}>
        <Detail  destory={popup.destory} />
      </section>,
      popup.dom
    );
  })
}

export default ShowWishDetail;